import * as React from "react";
import styled from "styled-components";
import RadioButton from "../../elements/RadioButton";
import Text from "../../elements/Text";
import { select } from "@hubper/theme";

// @ts-ignore
// tslint:disable-next-line:no-empty
function nope() {}

const Group = styled.div``;

const Row = styled.div`
  margin-bottom: ${select.space(1)};
  display: flex;
  align-items: center;

  & > *:first-child {
    margin-right: ${select.space(1)};
  }
`;

const CustomText = styled(Text)<{ value: boolean }>`
  color: ${select.color(["grey", 6])};
  cursor: ${p => (p.value ? "default" : "pointer")};
  user-select: none;

  &:hover {
    color: ${p =>
      p.value ? select.color(["grey", 6]) : select.color(["grey", 9])};
  }
`;

type RadioButtonRowProps = {
  selected?: boolean;
  onClick?: () => void;
  display: React.ReactNode;
};

function RadioButtonRow({ selected, onClick, display }: RadioButtonRowProps) {
  const [isOver, setOver] = React.useState(false);

  return (
    <Row>
      <RadioButton value={selected} onClick={onClick} over={isOver} />
      <CustomText
        onMouseEnter={() => setOver(true)}
        onMouseLeave={() => setOver(false)}
        onClick={selected ? nope : onClick}
        value={selected!}
        fs={-1}
      >
        {display}
      </CustomText>
    </Row>
  );
}

type Props = {
  value: string;
  onChange: (value: string) => void;
  enumMap: Record<string, string>;
  style?: React.CSSProperties;
  className?: string;
};

function RadioButtonGroup(
  { value, onChange, enumMap, style, className }: Props,
  ref: any
) {
  return (
    <Group ref={ref} style={style} className={className}>
      {Object.keys(enumMap).map(key => {
        const display = enumMap[key];
        const selected = value === key;

        return (
          <RadioButtonRow
            key={key}
            onClick={selected ? nope : () => onChange(key)}
            selected={selected}
            display={display}
          />
        );
      })}
    </Group>
  );
}

export default React.forwardRef(RadioButtonGroup);
